import React, { useState, useEffect } from 'react'
import { getRoomsAndCategorys, manageSocialRoom } from '../../actions/userActions';
import { connect } from 'react-redux'
import searchIcon from '../../img/ic__buscador.png'
import { Translate } from '../../language';
import circle from '../../img/circulogris.png';
import Modal from '../../containers/Modal';
import { ReactComponent as BackIcon } from '../../img/flecha-hacia-atras.svg';
import inMemoryJWT from '../../auth/inMemoryJwt';
import localStorage from '../../utils/hooks/useLocalStorage';



const SeeRoomsBySearch = ({ history, getRoomsAndCategorys, manageSocialRoom,roomsAndCategoryList, isLoading }) => {
    
    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }
    
        inMemoryJWT.waitForTokenRefresh().then(() => {
            getRoomsAndCategorys('')
        })
        
    },[])

    const [search, setSearch] = useState('')
    const [isShowModal, setIsShowModal] = useState(false)
    const [roomRules, setRoomRules] = useState(false)
    const [isValidate, setValidate] = useState(false)
    const [isAcceptTerms, setIsAcceptTerms] = useState(false)
    const [error, setError] = useState({})

    const selectModal = (e) => {
        setIsShowModal(!isShowModal)
    }

    const isChecked = () => {
        setIsAcceptTerms(!isAcceptTerms)


        if (!isAcceptTerms) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                [checkTermsOfServiceVar]: ''
            }));
        }

        var checkTermsOfServiceVar = 'checkTermsOfService'

        if (isAcceptTerms) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [checkTermsOfServiceVar]: Translate('isAcceptTerms', 'es')
            }));
        }
    }
    return (
        <div className="container-community-by-category relative">
            <div onClick={(e) => { history.go(-1) }} className="back-icon-css-community">
                <BackIcon className="cls-1" height="20" width="30" />
            </div>
            <div className='title-admin centerItems mb-4'>{'Buscar categoria y Salas'}</div>
            <div className="search-bar-navbar search-bar-navbar-community-by-category">
                <input
                    autoComplete="off"
                    className="input-inside-div"
                    name="search"
                    type="text"
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value)
                        getRoomsAndCategorys(e.target.value)
                    }}
                />
                <img src={searchIcon} alt="img" className="img-search-bar-right" />
            </div>
            <div className='title-admin'>Categorias</div>
            <div className='wrapper-5 column-gap parent-width centerItems centerContent mb-5'>
                {!isLoading &&
                    roomsAndCategoryList.results.categories.map((category) =>
                        <div onClick={() => history.push({
                            pathname: '/Communities/Category/' + category.name,
                            state: { idCategory: category._id }
                        })} className="community-category-container">
                            <div className="community-category-title">
                                {category.name}
                            </div>
                            <div className="community-category-sub-category-icon">
                                <div className="mb-1"> {'+'}</div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className='title-admin  mb-4'>Salas</div>
            <div className='wrapper-6 parent-width column-gap centerItems centerContent mt-5'>
                {isLoading ? <div></div> :
                    roomsAndCategoryList.results.rooms.map((room, index) =>
                        <div className="card-rooms-view">
                            <div onClick={(e) => {
                                selectModal(e)
                                setRoomRules(room.rules)
                            }} className="community-img-card-category">
                                <img src={room.profilePicture ? room.profilePicture.url : circle} alt="img" className="community-img-card-category" />
                            </div>
                            <div onClick={(e) => {
                                selectModal(e)
                                setRoomRules(room.rules)
                            }} className="column centerItems pointer">                               
                                <div className="">@{room.name}</div>
                            </div>
                            <div onClick={(e) => {
                                selectModal(e)
                                setRoomRules(room.rules)
                            }} className="btns-card-room">
                                Ingresar
                                </div>
                            <Modal
                                displayModal={isShowModal}
                                closeModal={selectModal}
                                content={<div className="rules-room-modal"> Normas:  {roomRules}
                                    <div className="column centerItems">
                                        <input
                                            name="checkTermsOfService"
                                            onClick={() => isChecked()}
                                            type="checkbox"
                                        />
                                        <div className="textBlack littleText" htmlFor="checkTermsOfService">
                                            Acepto las normas de la sala
                                </div>
                                    </div>
                                    <div className="text-error">{error.checkTermsOfService}</div>
                                    <button disabled={isValidate ? '' : 'disabled'}
                                        className={isValidate ? "btn btn-purple" : 'btn btn-inactive'} onClick={() => {
                                            manageSocialRoom({
                                                chatID: room._id,
                                                entityID: localStorage().getItem('idProfile'),
                                                adminID: room.adminID,
                                                type: 0
                                            })
                                        }} >Ingresar</button>
                                </div>}
                                typeModal='modal-access-room'
                            />
                        </div>
                    )
                }
            </div>
        </div>

    )
}
const mapStateToProps = (state) => {
    return {
        roomsAndCategoryList: state.userInfo.roomsAndCategorys,
        isLoading: state.userInfo.isLoadingListMyRoomsAndCategory
    }
}
export default connect(mapStateToProps, { getRoomsAndCategorys , manageSocialRoom })(SeeRoomsBySearch)
